import {repeat} from 'lit-html/directives/repeat';
import {until} from 'lit-html/directives/until';
import '../dropdown';
import {generalAriaLabels} from '@modules/i18n-labels';

export default (ctx, html) => html`
      ${repeat(ctx.supportedLangs, (i) => i.code, (item) => html`
        <button type="button"
        class="language-button ${item.enabled ? '' : 'd-none'}" 
        @click="${ctx.toggleLanguage}" data-lang="${item.code}">
          ${item.label}
        </button>
      `)}
`;